import React from "react";
import { Container } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="site-footer mt-auto">
      <Container className="footer-inner">
        <div>
          <strong>SPARKLOGIC</strong>
        </div>
        <small>© {new Date().getFullYear()} SparkLogic. All rights reserved.</small>
      </Container>
    </footer>
  );
};

export default Footer;
